export const environment = {
  production: false,
  backendUrl: 'http://localhost:3080'
};
